<script lang="ts">
  interface Props {
    title?: import('svelte').Snippet;
    paragraph?: import('svelte').Snippet;
    action?: import('svelte').Snippet;
  }

  let { title, paragraph, action }: Props = $props();
</script>

<div class="p-6 pt-8">
  <p class="mb-2 typography-body-xl-semibold">
    {@render title?.()}
  </p>
  <p>
    {@render paragraph?.()}
  </p>
  <div class="relative z-10 mt-4 grid gap-3">
    {@render action?.()}
  </div>
</div>
